export default function bodyScrollLock(bool: boolean): void {
  if (import.meta.client) {
    document.body.classList.toggle("scroll-lock", bool);
  }
}
